import React from "react"
import Img from 'gatsby-image'
import { FaInstagramSquare, FaFacebookSquare, FaTwitterSquare} from 'react-icons/fa'

import { AboutMeContainer } from "./style"

const AboutMe = ({about}) => {
  const {introduction, name, facebook, twitter, instagram, profile_picture } = about

  return (
    <AboutMeContainer>
      <Img fluid={profile_picture.asset.fluid} alt={name }/>
      <h3>{name}</h3>
      <p>
        {introduction}
      </p>
      <ul>
        <li>
          <a href={facebook} target="_blank">
            <FaFacebookSquare />
          </a>
        </li>
        <li>
          <a href={instagram} target="_blank">
            <FaInstagramSquare />
          </a>
        </li>
        <li>
          <a href={twitter} target="_blank">
            <FaTwitterSquare />
          </a>
        </li>
      </ul>
    </AboutMeContainer>
  )
}

export default AboutMe
